import type { Papel } from "@base/contracts";

export const ROTULO_DO_PAPEL: Readonly<Record<Papel, string>> = {
  admin: "Administrador",
  usuario: "Cliente",
};

/**
 * Mesma regra da API: o papel admin e a equipe Monte (escopos usuarios:* e
 * clientes:*). Aqui decide so o que mostrar; quem protege e o servidor.
 */
export function podeGerenciarUsuarios(papel: Papel): boolean {
  return papel === "admin";
}

/** Iniciais para o avatar: "Ana Souza" -> "AS". */
export function iniciaisDe(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  const primeira = partes[0]?.[0] ?? "";
  const ultima = partes.length > 1 ? (partes.at(-1)?.[0] ?? "") : "";
  return `${primeira}${ultima}`.toUpperCase();
}
